const files = require.context('./modules', false, /\.js$/)
const apis = files.keys().reduce((pre, next) => {
  const moduleApis = files(next).default
  const baseUrl = files(next).baseUrl
  moduleApis.forEach((api) => {
    api.storeKey = api.storeKey || api.url
    if (!JSON.parse(process.env.VUE_APP_LIVE) && baseUrl) {
      api.url = baseUrl + api.url
    }
  })
  const path = /^\.\/(.+)\.js$/.exec(next)[1]
  return [...pre, [path, moduleApis]]
}, [])

export default apis
